import { pilot } from '~/services/serviceInstances';

interface Request {
  files: File[];
}

interface AttachmentResponse {
  id: string;
  fileName: string;
  fileType: string;
}

type Response = AttachmentResponse[];

export const uploadAttachments = async (
  request: Request,
): Promise<Response> => {
  const { files } = request;

  const promises = files.map((file) => {
    const formData = new FormData();
    formData.append('file', file);
    return pilot.post<AttachmentResponse>('/attachment/', formData);
  });

  const promisesResolved = promises.map((promise) =>
    promise.catch((): AttachmentResponse | null => null),
  );

  const results = await pilot.concurrentRequests<AttachmentResponse | null>(
    promisesResolved,
  );

  return results.filter(
    (result): result is AttachmentResponse => result !== null,
  );
};
